/**
 * Convert 2-letter country code to flag emoji
 * e.g. "DK" → 🇩🇰, "DE" → 🇩🇪
 */
export const countryToFlag = (code) => {
  if (!code || code.length !== 2) return '';
  return String.fromCodePoint(
    ...code.toUpperCase().split('').map(c => c.charCodeAt(0) + 127397)
  );
};

/** All supported countries for the selector — global list */
export const EUROPEAN_COUNTRIES = [
  // ─── Europe ───
  { code: 'AL', name: 'Albanien' },
  { code: 'AD', name: 'Andorra' },
  { code: 'AM', name: 'Armenien' },
  { code: 'AT', name: 'Østrig' },
  { code: 'AZ', name: 'Aserbajdsjan' },
  { code: 'BY', name: 'Hviderusland' },
  { code: 'BE', name: 'Belgien' },
  { code: 'BA', name: 'Bosnien-Hercegovina' },
  { code: 'BG', name: 'Bulgarien' },
  { code: 'HR', name: 'Kroatien' },
  { code: 'CY', name: 'Cypern' },
  { code: 'CZ', name: 'Tjekkiet' },
  { code: 'DK', name: 'Danmark' },
  { code: 'EE', name: 'Estland' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'Frankrig' },
  { code: 'GE', name: 'Georgien' },
  { code: 'DE', name: 'Tyskland' },
  { code: 'GR', name: 'Grækenland' },
  { code: 'HU', name: 'Ungarn' },
  { code: 'IS', name: 'Island' },
  { code: 'IE', name: 'Irland' },
  { code: 'IT', name: 'Italien' },
  { code: 'XK', name: 'Kosovo' },
  { code: 'LV', name: 'Letland' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LT', name: 'Litauen' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MT', name: 'Malta' },
  { code: 'MD', name: 'Moldova' },
  { code: 'MC', name: 'Monaco' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'NL', name: 'Holland' },
  { code: 'MK', name: 'Nordmakedonien' },
  { code: 'NO', name: 'Norge' },
  { code: 'PL', name: 'Polen' },
  { code: 'PT', name: 'Portugal' },
  { code: 'RO', name: 'Rumænien' },
  { code: 'RU', name: 'Rusland' },
  { code: 'SM', name: 'San Marino' },
  { code: 'RS', name: 'Serbien' },
  { code: 'SK', name: 'Slovakiet' },
  { code: 'SI', name: 'Slovenien' },
  { code: 'ES', name: 'Spanien' },
  { code: 'SE', name: 'Sverige' },
  { code: 'CH', name: 'Schweiz' },
  { code: 'TR', name: 'Tyrkiet' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'GB', name: 'Storbritannien' },
  { code: 'VA', name: 'Vatikanstaten' },
  // ─── Middle East ───
  { code: 'BH', name: 'Bahrain' },
  { code: 'IQ', name: 'Irak' },
  { code: 'IR', name: 'Iran' },
  { code: 'IL', name: 'Israel' },
  { code: 'JO', name: 'Jordan' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'LB', name: 'Libanon' },
  { code: 'OM', name: 'Oman' },
  { code: 'PS', name: 'Palæstina' },
  { code: 'QA', name: 'Qatar' },
  { code: 'SA', name: 'Saudi-Arabien' },
  { code: 'SY', name: 'Syrien' },
  { code: 'AE', name: 'UAE' },
  { code: 'YE', name: 'Yemen' },
  // ─── Africa ───
  { code: 'DZ', name: 'Algeriet' },
  { code: 'AO', name: 'Angola' },
  { code: 'CM', name: 'Cameroun' },
  { code: 'CI', name: 'Elfenbenskysten' },
  { code: 'EG', name: 'Egypten' },
  { code: 'ET', name: 'Etiopien' },
  { code: 'GH', name: 'Ghana' },
  { code: 'KE', name: 'Kenya' },
  { code: 'LY', name: 'Libyen' },
  { code: 'MA', name: 'Marokko' },
  { code: 'MZ', name: 'Mozambique' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'SN', name: 'Senegal' },
  { code: 'ZA', name: 'Sydafrika' },
  { code: 'SD', name: 'Sudan' },
  { code: 'TZ', name: 'Tanzania' },
  { code: 'TN', name: 'Tunesien' },
  { code: 'UG', name: 'Uganda' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabwe' },
  // ─── Asia ───
  { code: 'AF', name: 'Afghanistan' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'CN', name: 'Kina' },
  { code: 'HK', name: 'Hongkong' },
  { code: 'IN', name: 'Indien' },
  { code: 'ID', name: 'Indonesien' },
  { code: 'JP', name: 'Japan' },
  { code: 'KZ', name: 'Kasakhstan' },
  { code: 'KR', name: 'Sydkorea' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'MN', name: 'Mongoliet' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'NP', name: 'Nepal' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'PH', name: 'Filippinerne' },
  { code: 'SG', name: 'Singapore' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'TW', name: 'Taiwan' },
  { code: 'TH', name: 'Thailand' },
  { code: 'UZ', name: 'Usbekistan' },
  { code: 'VN', name: 'Vietnam' },
  // ─── Americas ───
  { code: 'AR', name: 'Argentina' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BR', name: 'Brasilien' },
  { code: 'CA', name: 'Canada' },
  { code: 'CL', name: 'Chile' },
  { code: 'CO', name: 'Colombia' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'CU', name: 'Cuba' },
  { code: 'DO', name: 'Dominikanske Republik' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'HN', name: 'Honduras' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'MX', name: 'Mexico' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'PA', name: 'Panama' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Peru' },
  { code: 'PR', name: 'Puerto Rico' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'TT', name: 'Trinidad og Tobago' },
  { code: 'US', name: 'USA' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'VE', name: 'Venezuela' },
  // ─── Oceania ───
  { code: 'AU', name: 'Australien' },
  { code: 'FJ', name: 'Fiji' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'PG', name: 'Papua New Guinea' },
];
